import {Component, EventEmitter, Output} from "@angular/core";
import {FUIModalsService} from "@fedeltapointofsale/ui";

export class Refund {
    constructor(public amount: number, public qty: number) {
    }
}

@Component({
    selector: "sales-journal-payment-refund",
    templateUrl: "./sales-journal-payment-refund.component.html",
    styleUrls: ["./sales-journal-payment-refund.component.scss"]
})
export class SalesJournalPaymentRefundComponent {

    paymentTotal: number;
    remainingAmount: number;
    itemPrice: number;
    itemQty: number;
    itemRefundedQty: number;
    consumeRemainingAmount: boolean;

    refundAmount: number;
    refundQty: number = 1;

    state: boolean = true;

    @Output() onConfirm: EventEmitter<Refund> = new EventEmitter();

    constructor(private modalsService: FUIModalsService) {
    }

    cancel(): void {
        this.modalsService.close(this);
        this.onConfirm.complete();
    }

    confirm(): void {
        this.modalsService.close(this);
        this.onConfirm.emit(new Refund(this.refundAmount, this.refundQty));
        this.onConfirm.complete();
    }

    setValues(paymentTotal: number, remainingAmount: number, itemPrice?: number, itemQty?: number, itemRefundedQty?: number, consumeRemainingAmount: boolean = false): void {
        this.paymentTotal = paymentTotal;
        this.remainingAmount = remainingAmount;
        this.itemPrice = itemPrice;
        this.itemQty = itemQty;
        this.itemRefundedQty = itemRefundedQty;
        this.consumeRemainingAmount = consumeRemainingAmount;
        if (this.isForItem) {
            this.calculateItemRefundAmount();
        }
    }

    get isForItem(): boolean {
        return this.itemPrice !== undefined;
    }

    get canDecrementRefundQty(): boolean {
        return this.refundQty > 1;
    }

    get canIncrementRefundQty(): boolean {
        return this.refundQty < this.itemQty - (this.itemRefundedQty || 0);
    }

    decrementRefundQty(): void {
        if (this.canDecrementRefundQty) {
            this.refundQty--;
            this.calculateItemRefundAmount();
        }
    }

    incrementRefundQty(): void {
        if (this.canIncrementRefundQty) {
            this.refundQty++;
            this.calculateItemRefundAmount();
        }
    }

    calculateItemRefundAmount(): void {
        // Refunding the last item on the order refunds the full outstanding payment amount.
        // Otherwise, the amount is limited by the remaining amount.
        this.refundAmount = this.consumeRemainingAmount && !this.canIncrementRefundQty ? this.remainingAmount : Math.min(this.refundQty * this.itemPrice, this.remainingAmount);
    }
}
